// src/services/notificationsAdminService.js
import { apiService } from './api';

export const notificationsAdminService = {
  getNotifications: async () => {
    try {
      const response = await apiService.get('/notifications/supadmin', {}, true);
      return response.data || response;
    } catch (error) {
      console.error('❌ Erreur getNotifications:', error);
      throw error;
    }
  },

  createNotification: async (notificationData) => {
    try {
      const response = await apiService.post('/notifications/supadmin', notificationData);
      return response.data;
    } catch (error) {
      console.error('❌ Erreur createNotification:', error);
      throw error;
    }
  },

  toggleBulkActive: async (filter) => {
    try {
      const response = await apiService.post('/notifications/supadmin/bulk-toggle-active', filter);
      return response.data;
    } catch (error) {
      console.error('❌ Erreur toggleBulkActive:', error);
      throw error;
    }
  },

  deleteBulkNotifications: async (filter) => {
    try {
      const response = await apiService.post('/notifications/supadmin/bulk-delete', filter);
      return response.data;
    } catch (error) {
      console.error('❌ Erreur deleteBulkNotifications:', error);
      throw error;
    }
  },

  deleteNotification: async (notificationId) => {
    try {
      const response = await apiService.delete(`/notifications/supadmin/${notificationId}`, {}, true);
      return response.data;
    } catch (error) {
      console.error('❌ Erreur deleteNotification:', error);
      throw error;
    }
  }
};